import { render, staticRenderFns } from "./ShelfRow.vue?vue&type=template&id=85d07098&scoped=true&"
import script from "./ShelfRow.vue?vue&type=script&lang=ts&"
export * from "./ShelfRow.vue?vue&type=script&lang=ts&"
import style0 from "./ShelfRow.vue?vue&type=style&index=0&id=85d07098&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85d07098",
  null
  
)

export default component.exports